<template>
  <div style="background-color: #f6f8ff;">
    <div v-if="liad_show">
      <load></load>
    </div>
    <div class="maincon">
      <div class="chars">
        <div class="left card" style="margin: 0;" id="wi">
          <h3 style="text-align: center;">账号使用</h3>
          <div id="bingzhuang" class="char"></div>
        </div>
        <div class="left card">
          <h3 style="text-align: center;">每月新增视频数</h3>
          <div id="zhuzhuang" class="char"></div>
        </div>
        <div class="left card">
          <h3 style="text-align: center;">近一周登录情况</h3>
          <div id="zhexian" class="char"></div>
        </div>
        <div class="left card">
          <h3 style="text-align: center;">空间使用情况</h3>
          <div id="yuanhuan" class="char"></div>
        </div>
      </div>

      <div class="newcourse">
        <h2 class="left">最新课程</h2>
        <a href="/Yzcourse" class="right">>>>更多</a>
        <el-row>
          <el-col class="eachc" v-for="(item, index) in videoList" :key="index" :offset="index > 0 ? 15 : 0 "  >
              <el-card :body-style="{ padding: '10px','cursor':'pointer' }" @click.native="watch_video(item.serial_number)" >
                <div class="imgh" >
                  <img :src=item.img
                    class="image">
                </div>
                <div style="padding: 5px;">
                  <h3 style="margin: 0; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{item.name}}</h3>
                  <div class="bottom clearfix">
                    <p style="margin: 0;" class="left">{{item.level}}</p>
                    <p style="margin: 0;" class="right">{{item.teacher}}</p>
                  </div>
                </div>
              </el-card>
          </el-col>
        </el-row>
      </div>
      <div class="newtask">
        <h2 class="left">最新任务</h2>
        <a href="/Task" class="right">>>>更多</a>
        <el-table :data="tableData" stripe>
          <el-table-column prop="num" label="编号" sortable>
          </el-table-column>
          <el-table-column prop="name" label="主题" sortable>
          </el-table-column>
          <el-table-column prop="t_id" label="分类" sortable>
          </el-table-column>
          <el-table-column prop="role_type" label="培训级别" sortable>
          </el-table-column>
          <el-table-column prop="a_id" label="派发人" sortable>
          </el-table-column>
          <el-table-column prop="c_time" label="创建时间" sortable>
          </el-table-column>
          <el-table-column prop="start_time" label="开始时间" sortable>
          </el-table-column>
          <el-table-column prop="end_time" label="结束时间" sortable>
          </el-table-column>
          <el-table-column prop="number" label="学员数" sortable>
          </el-table-column>
          <el-table-column  label="状态" sortable>
            <template slot-scope="scope">
              <span v-if="scope.row.status=='0'">编辑中</span>
              <span v-if="scope.row.status=='1'">启用中</span>
              <span v-if="scope.row.status=='2'">已禁用</span>
              <span v-if="scope.row.status=='3'">已删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

  </div>
</template>

<script>
  import load from '../../components/load.vue';
  const echarts = require('echarts/lib/echarts');
  require('echarts/lib/component/title');
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/legend');
  require('echarts/lib/chart/pie');
  require('echarts/lib/component/grid');
  require('echarts/lib/chart/bar');
  require('echarts/lib/chart/line');
  export default {
    data() {
      return {
        liad_show:false,
        char_list:{},
        char_binghzuang:{},
        char_zhuzhuang:{},
        char_zhexian:{},
        char_kjshiyong:{},
        videoList:[],
        colors1: [
          '#3682be',
          '#334f65',
          '#0c84c6',
          '#ffa510',
          '#ffbd66',
          '#f74d4d',
          '#41b7ac'
        ],
        tableData: [],
      }
    },
    components: {
      load:load
    },
    mounted: function() {
      this.get_used();
    },
    methods: {
      get_used(){
        let _this = this;
        _this.liad_show=true
        _this.axios.get("/v2/c_companyee/get_used").then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.char_binghzuang=res.data.data;
              _this.get_video_new_add();
            } else {
              _this.$message.error("服务器内部错误");
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      get_video_new_add(){
        let _this = this
          _this.axios
        .get("/v2/c_resource/get_video_new_add")
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
             _this.char_zhuzhuang=res.data.data
             let data=[]
              let public11=[]
              let local=[]
               for(let i=0;i<_this.char_zhuzhuang.length;i++){
                data.push(_this.char_zhuzhuang[i].date)
                public11.push(_this.char_zhuzhuang[i].public)
                local.push(_this.char_zhuzhuang[i].local)
               }
               _this.char_zhuzhuang['time']=data
               _this.char_zhuzhuang['public']=public11
               _this.char_zhuzhuang['local']=local
               _this.get_week_login()
            } else {
              _this.$message.error("服务器内部错误")
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },
      get_week_login(){
        let _this = this
          _this.axios
        .get("/v2/c_companyee/get_week_login")
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
             _this.char_zhexian=res.data.data
             let data=[]
              let num=[]
               for(let i=0;i<_this.char_zhexian.length;i++){
                data.push(_this.char_zhexian[i].week)
                num.push(_this.char_zhexian[i].num)
               }
               _this.char_zhexian['time']=data
               _this.char_zhexian['num']=num
               _this.get_space()
            } else {
              _this.$message.error("服务器内部错误")
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        })
      },
      get_space(){
        let _this = this
          _this.axios
        .get("/v2/c_company/get_space")
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
             _this.char_kjshiyong=res.data.data
               _this.char1()
               _this.get_video_new()
            } else {
              _this.$message.error("服务器内部错误")
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        })
      },
      get_video_new(){
        let _this = this;
          _this.axios
        .get(" /v2/c_resource/get_video_new")
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.videoList=res.data.data
              _this.get_taskList()
            } else {
              _this.$message.error("服务器内部错误")
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },
      get_taskList(){
        let _this = this
          _this.axios
        .get("/v2/c_train/get_list", {params:{page:'1',limit:'10',type:'0'}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.tableData=res.data.data.list
              for(let i=0;i<_this.tableData.length;i++){
                _this.tableData[i]['number']=_this.tableData[i]['companyee'].length
                if(_this.tableData[i].role_type=='0'){
                  _this.tableData[i].role_type="企业级"
                }else if(_this.tableData[i].role_type=='1'){
                   _this.tableData[i].role_type="部门级"
                }else if(_this.tableData[i].role_type=='2'){
                   _this.tableData[i].role_type="个人级"
                }
              }
            } else {
              _this.$message.error("服务器内部错误")
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
        _this.liad_show=false
      },

      watch_video(num){
        let routeData = this.$router.resolve({
          query: {num:num,type:0,resource:'v'},
          path:'/courseplay'
        });
        window.open(routeData.href, '_blank')
      },

      watch_train(scope){
        // console.log(scope)
      },

      char1() {
              let _this = this
              var chartDom = document.getElementById('bingzhuang')
              _this.char_list.char1 = echarts.init(chartDom)
              var option = {
                color: _this.colors1,
                tooltip: {
                  trigger: 'item'
                },
                legend: {
                },
                series: [{
                  name: '账号使用情况',
                  type: 'pie',
                  radius: '50%',
                  data: [{
                      value: _this.char_binghzuang.free,
                      name: '未使用账号'
                    },
                    {
                      value: _this.char_binghzuang.used,
                      name: '已使用账号'
                    },
                  ],
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  }
                }]
              };
              option && _this.char_list.char1.setOption(option);
              _this.char2()
            },
      char2() {

              let _this = this;
              var chartDom = document.getElementById('zhuzhuang');
              _this.char_list.char2 = echarts.init(chartDom);
              var option = {
                color: _this.colors1,
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'shadow'
                  }
                },
                legend: {
                  data: ['药知视频新增', '内部视频新增']
                },
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: {
                  type: 'category',
                  data:  _this.char_zhuzhuang.time
                },
                yAxis: {
                  type: 'value'
                },
                series: [{
                    name: '药知视频新增',
                    type: 'bar',
                    data:  _this.char_zhuzhuang.public
                  },
                  {
                    name: '内部视频新增',
                    type: 'bar',
                    data:_this.char_zhuzhuang.local
                  }
                ]
              };
              option && _this.char_list.char2.setOption(option);
              _this.char3()
            },
      char3() {
        let _this = this;
        console.log(_this.char_zhexian)
        var chartDom = document.getElementById('zhexian');
        _this.char_list.char3 = echarts.init(chartDom);
        var option;
        option = {
          color: _this.colors1,
          xAxis: {
            type: 'category',
            name: '日期',
            boundaryGap: false,
            data: _this.char_zhexian.time
          },
          yAxis: {
            type: 'value',
            name: '人次'
          },
          series: [{
            data: _this.char_zhexian.num,
            type: 'line',
            areaStyle: {}
          }]
        };
        option && _this.char_list.char3.setOption(option);
        _this.char4()
      },
      char4() {
        let _this = this;
        var chartDom = document.getElementById('yuanhuan');
        _this.char_list.char4 = echarts.init(chartDom);
        var option = {
          color: _this.colors1,
          tooltip: {
            trigger: 'item'
          },
          legend: {
            width: '100%',
            left: 'center'
          },
          series: [{
            name: '空间使用情况',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [{
                value: _this.char_kjshiyong.used,
                name: '已使用空间'
              },
              {
                value:(_this.char_kjshiyong.total-_this.char_kjshiyong.used),
                name: '未使用空间'
              }
            ]
          }]
        }
        option && _this.char_list.char4.setOption(option);
        _this.char_end()
      },
      char_end(){
        let _this=this
        setTimeout(function() {
          window.onresize = function() {
            _this.char_list.char1.resize();
            _this.char_list.char2.resize();
            _this.char_list.char3.resize();
            _this.char_list.char4.resize();
          }
        }, 200)
      }
    }
  }
</script>

<style scoped>
  .card {
    width: calc(25% - 35px);
    margin-left: 20px;
    padding: 10px;
    background-color: white;
  }

  .char {
    width: 100%;
    min-height: 250px;
  }

  .maincon {
    padding: 20px;
    height: calc(100vh - 40px);
    overflow-y: auto;
  }

  /* 卡片 */
  .el-row {
    width: 100%;
    overflow: hidden;
  }

  .image {
    width: 100%;
    display: block;
    height: 100%;
    position: absolute;
  }

  .imgh {
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    position: relative;
  }

  .eachc {
    margin: 10px;
    width: calc(25% - 20px);
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  .chars {
    margin-bottom: 20px;
    overflow: hidden;
  }

  .newcourse {
    margin: 20px 0;
    background-color: white;
    padding: 20px;
    overflow: hidden;
  }

  .newtask {
    margin-top: 20px;
    background-color: white;
    padding: 20px;
  }

  h2 {
    margin-top: 0;
  }



  .dobtn {
    margin: 0 5px;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/chome.vue